<script setup lang="ts">
import { readSingleton } from '@directus/sdk'

const { locale } = useI18n()
const { request } = useDirectusRest()

const { data: content } = await useAsyncData(
  'content-features',
  () =>
    request(
      readSingleton('content', {
        deep: {
          translations: {
            _filter: {
              languages_code: {
                _eq: locale.value,
              },
            },
          },
        },
        fields: ['id', { translations: ['features'] }],
      }),
    ),
  {
    transform: (result) => {
      return result.translations[0]
    },
    watch: [locale],
  },
)
</script>

<template>
  <div class="isolate">
    <ClipAngle angle="right" background="sunglow-500" foreground="black" />
    <div class="z-10 bg-black px-5 py-24">
      <div
        class="mx-auto flex max-w-7xl flex-col flex-wrap justify-center gap-x-24 gap-y-16 md:flex-row"
      >
        <div
          :key="`features-${index}`"
          class="grid grid-cols-[auto_1fr] gap-6"
          v-for="(item, index) in content?.features || []"
        >
          <div class="w-10">
            <NuxtImg alt="" :src="`/img/check.svg`" />
          </div>
          <div>
            <h3 class="text-3xl font-bold text-white">{{ item.title }}</h3>
            <div
              class="prose prose-invert mt-5 !max-w-[20ch] font-semibold leading-[22px] text-white prose-p:text-white prose-li:text-white prose-li:marker:text-white"
              v-html="item.text"
            />
          </div>
        </div>
      </div>
    </div>
    <ClipAngle background="white" class="rotate-180" foreground="black" />
  </div>
</template>
